import './components/sliders/useFlickity'
import './components/sliders/useFlickityOtherServices'
import './components/sliders/useFlickityContainersMb'
import './components/sliders/useFlickityViewInfrastructureMb'
import './components/sliders/useFlickityOnlyDesktop'
import './components/forms/search-block-form'
import './components/forms/viewDayHealth'
import './components/blocks/blocks/blockVolver'
import './components/blocks/blocks/blockEncabezado'
import './components/blocks/selectlanguage/selectlanguage'
import './components/blocks/videolife/videoLife'
import './components/footer/footer'
import './components/blocks/brands/brands'
import './components/blocks/body/checkListItemsColumns'
import './components/blocks/howtoreachus/howtoreachus'
import './components/content/cvEspecialista'
import './components/content/servicios'
import './components/paragraph/_p--type--our-plans'
import './components/paragraph/_p--type--card-6-6'
import './components/paragraph/_p--type--detailcardcontainer'
import './components/paragraph/_p--type--acordeon'
import './components/tabs/createTabsFromAccordion'
import './components/tabs_slider_mobile/tabsSliderMobile'
import './components/header/addButtonToNavbarCollapse'
import './components/header/positionBody'
import './components/header/activeServices'


import './components/banner/bannerMain'
import './components/blocks/map/clinicMap'
import './components/blocks/map/howCanYou'
import './components/blocks/modal/modalpqrs'
import './components/doctor/cta-doctor'
import './components/node/ctaShare'
import './components/node/alDiaConTuSalud'
import './components/node/research-and-education'
import './components/views/contactCardsClinics'
import './components/paginator/paginator'

import './utils/changeReadMoreText'
import './utils/moveContainerData'
import './utils/forward'

import './services/_s--sofia'
import './services/_s--form-validation'

